module.exports = __webpack_public_path__ + "img/example-living-image.9385700b.jpg";